import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'gg-wellness-offerings-icon',
  templateUrl: './wellness-offerings-icon.component.html',
  styleUrls: ['./wellness-offerings-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WellnessOfferingsIconComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
